export const mediaQueryConfig = {
  vertical: "1080px",
  t2Vertical: "360px",
};
